<!-- 农业管理首页 -->
<template>
    <MainLayout class="main-layout" style="height: calc(100% - 16px); padding: 0px 8px" rightWidth="320px"
        @toggleRight="handleToggleRight">
        <News slot="header"> </News>
        <!-- 左侧 -->
        <LeftAside slot="left" :treeData="plotTree" :activeId="activeFieldId" @node-click="handleNodeClick"
            @select="handleFieldSelect" @search="handleSearch" @delete="handleDelete" @edit="handleEdit"></LeftAside>
        <!-- 中间地图 -->
        <div ref="middlRef" slot="main" class="c-middle" style="padding: 12px">
            <MapContainer ref="mapRef" :useServiceConfigZoom="false" :zoom="13">
                <template slot="openlayer">
                    <MapLayer :fields="fieldList" :waterPoints="waterPointList" :takeoffPoints="takeoffPointList"
                        @field-click="handleFieldClick"></MapLayer>
                </template>
            </MapContainer>

            <!-- 地块详情弹窗 -->
            <FieldInfoDialog :visible.sync="dialogVisible" :plotId="currentPlotId" @view-source="handleViewSource"
                @view-photos="handleViewPhotos" @close="dialogVisible = false" />
        </div>
        <Right slot="right" :rightShow="rightShow" :overviewList="overviewList" :cropList="cropList"
            :plantingList="plantingList" @handleDateChange="handleDateChange"></Right>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout';
import News from '@/page/mainPage/components/news/News.vue';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import LeftAside from '../components/LeftAside.vue';
import MapLayer from '../components/MapLayer.vue';
import Right from '../components/Right.vue';
import FieldInfoDialog from '../components/FieldInfoDialog.vue';
import NongyeApi from '../api';
import UtilS from '@/page/business/util/map';

export default {
    components: {
        MainLayout,
        News,
        MapContainer,
        LeftAside,
        MapLayer,
        Right,
        FieldInfoDialog,
    },
    data () {
        return {
            rightShow: false,
            activeFieldId: null,
            plotTree: [],
            plotList: [],
            waterPointList: [],
            takeoffPointList: [],
            overviewList: [],
            cropList: [],
            plantingList: [],
            dialogVisible: false,
            currentPlotId: null,
        };
    },
    computed: {
        fieldList () {
            const list = [];
            const walk = (nodes) => {
                if (!Array.isArray(nodes)) return;
                nodes.forEach((node) => {
                    if (node && node.nodeType === 'plot') {
                        const plant = Array.isArray(node.plantList) && node.plantList.length ? node.plantList[0] : {};
                        list.push({
                            id: node.id,
                            name: node.name,
                            plotCode: node.plotCode,
                            plotName: node.plotName,
                            area: node.area,
                            landType: node.landType,
                            cropName: plant.cropName || node.landType,
                            cropImgUrl: plant.cropImgUrl || '',
                            centerLng: node.centerLng,
                            centerLat: node.centerLat,
                            address: node.address,
                            plantDate: plant.plantingDate || '',
                            harvestDate: plant.expectedHarvestDate || '',
                            status: node.status,
                            plantList: node.plantList || [],
                            coordinates: this.parseWkt(node.boundary),
                        });
                    }
                    if (node && node.children) walk(node.children);
                });
            };
            walk(this.plotTree);
            return list;
        },
    },
    created () {
    },
    mounted () {
        this.getPlotTree();
    },
    methods: {
        // 切换右侧图表显示
        handleDateChange (val) {
            this.loadStatistics(val);
        },
        // 加载统计信息
        async loadStatistics (val) {
            let params = val || {};
            console.log('params', params);
            try {
                const [totalRes, areaRes, statusRes] = await Promise.all([
                    NongyeApi.countAgriPlot(params),
                    NongyeApi.countPlantArea(params),
                    NongyeApi.countPlantStatus(params),
                ]);
                const total = totalRes?.data || totalRes || {};
                const cropColors = ['#49f0fd', '#ef8200', '#7df5b0', '#a48bff', '#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff'];
                const statusIcons = [
                    { icon: 'icon-plant-1', bg: 'rgba(73, 240, 253, 0.3)' },
                    { icon: 'icon-plant-2', bg: 'rgba(239, 130, 0, 0.3)' },
                    { icon: 'icon-plant-3', bg: 'rgba(167, 139, 250, 0.3)' },
                    { icon: 'icon-plant-4', bg: 'rgba(125, 245, 176, 0.3)' },
                ];
                this.overviewList = [
                    { url: 'icon-ny-1', name: '地块数量', unit: '块', value: total.plotCount ?? 0 },
                    { url: 'icon-ny-2', name: '种植面积', unit: '亩', value: total.plantArea ?? 0 },
                    { url: 'icon-ny-3', name: '作业次数', unit: '次', value: total.farmCount ?? 0 },
                    { url: 'icon-ny-4', name: '作业面积', unit: '亩', value: total.farmArea ?? 0 },
                    { url: 'icon-ny-5', name: '农业需求数', unit: '单', value: total.serviceCount ?? 0 },
                    { url: 'icon-ny-6', name: '无人机作业次数', unit: '次', value: total.flightCount ?? 0 },
                ];
                const areaList = areaRes?.rows || areaRes?.data || (Array.isArray(areaRes) ? areaRes : []);
                this.cropList = (Array.isArray(areaList) ? areaList : []).map((item, idx) => ({
                    name: item.name,
                    code: item.code,
                    value: item.value ?? 0,
                    unit: '亩',
                    color: cropColors[idx % cropColors.length],
                }));
                const statusList = statusRes?.rows || statusRes?.data || (Array.isArray(statusRes) ? statusRes : []);
                this.plantingList = (Array.isArray(statusList) ? statusList : []).map((item, idx) => {
                    const cfg = statusIcons[idx % statusIcons.length];
                    return {
                        name: item.name,
                        code: item.code,
                        value: item.value ?? 0,
                        unit: '块',
                        label: item.name,
                        icon: cfg.icon,
                        bg: cfg.bg,
                    };
                });
            } catch (e) {
                console.error('[Nongye Index] loadStatistics 异常', e);
            }
            this.waterPointList = [
                { id: 'w1', name: '北侧取水口', lon: 113.270, lat: 23.142 },
                { id: 'w2', name: '南侧取水口', lon: 113.268, lat: 23.118 },
            ];
            this.takeoffPointList = [
                { id: 't1', name: '机库A', lon: 113.273, lat: 23.130 },
                { id: 't2', name: '机库B', lon: 113.262, lat: 23.140 },
            ];
        },
        // 解析WKT字符串为多边形坐标
        parseWkt (boundary) {
            if (!boundary) return [];
            try {
                if (typeof UtilS?.WKTtoParsePolygon === 'function') {
                    const parsed = UtilS.WKTtoParsePolygon(boundary);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                        return [parsed];
                    }
                }
            } catch (e) {
                // ignore
            }
            return [];
        },
        // 获取地块树
        async getPlotTree (val) {
            try {
                const res = await NongyeApi.listAgriPlotTreeBs({
                    codeOrName: val || '',
                });
                this.plotTree = res?.data || res?.rows || res || [];
                console.log('this.plotTree', this.plotTree);
            } catch (e) {
                this.$message.error('获取地块树失败');
                this.plotTree = [];
            }
        },
        // 点击地块
        handleFieldClick (field) {
            this.currentPlotId = field.id;
            this.dialogVisible = true;
        },
        // 选择地块
        handleFieldSelect (item) {
            this.activeFieldId = item.id;
            this.$message.success(`已选中：${item.plotName || item.name}`);
        },
        // 点击节点
        handleNodeClick (data) {
            this.activeFieldId = data.id;
        },
        // 搜索地块
        async handleSearch (params) {
            try {
                console.log('handleSearch', params);
                this.getPlotTree(params?.keyword || '');
            } catch (e) {
                this.$message.error('搜索地块失败');
            }
        },
        // 删除地块
        async handleDelete (data) {
            await this.getPlotTree();
            if (this.activeFieldId === data.id) this.activeFieldId = null;
        },
        // 编辑地块
        handleEdit (data) {
            this.$message.info(`编辑地块：${data.plotName || data.name}`);
        },
        // 切换右侧图表显示
        handleToggleRight (visible) {
            this.rightShow = visible;
        },
        /**
         * 处理查看溯源码事件
         * @param {Object|string} payload - 地块信息，支持对象形式{ id }或直接传id值
         */
        handleViewSource (payload) {
            const id = payload?.id || payload;
            this.$message.info(`查看溯源码：地块 ${id}`);
        },
        // 查看照片
        handleViewPhotos (payload) {
            const id = payload?.id || payload;
            this.$message.info(`查看照片：地块 ${id}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-layout {
    height: calc(100% - 16px);
    padding: 0px 8px;
}

.c-middle {
    width: 100%;
    height: 100%;
}
</style>
